module.exports = __webpack_public_path__ + "static/img/96ce570fd64da1ef608de83a9361aa8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mode1-show-2.png
// module id = P1Fe
// module chunks = 1